import { render, staticRenderFns } from "./UnifiedMenu.vue?vue&type=template&id=314120a3&scoped=true&"
import script from "./UnifiedMenu.vue?vue&type=script&lang=js&"
export * from "./UnifiedMenu.vue?vue&type=script&lang=js&"
import style0 from "./UnifiedMenu.vue?vue&type=style&index=0&id=314120a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314120a3",
  null
  
)

export default component.exports